declare namespace $ {

	type $bog_blitz_admin_bot__on_quiz_bog_blitz_admin_1 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin['import_bot_quiz'] >
		,
		ReturnType< $bog_blitz_admin_bot['on_quiz'] >
	>
	type $mol_paragraph__title_bog_blitz_admin_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_textarea__value_bog_blitz_admin_3 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin['import_json_text'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_button_major__title_bog_blitz_admin_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_blitz_admin_5 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin['import_json'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_paragraph__title_bog_blitz_admin_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $bog_blitz_admin_quiz__quiz_title_bog_blitz_admin_7 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin['quiz_title'] >
		,
		ReturnType< $bog_blitz_admin_quiz['quiz_title'] >
	>
	type $bog_blitz_admin_quiz__is_shared_bog_blitz_admin_8 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin['quiz_is_shared'] >
		,
		ReturnType< $bog_blitz_admin_quiz['is_shared'] >
	>
	type $bog_blitz_admin_quiz__edit_bog_blitz_admin_9 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin['edit_quiz'] >
		,
		ReturnType< $bog_blitz_admin_quiz['edit'] >
	>
	type $bog_blitz_admin_quiz__delete_bog_blitz_admin_10 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin['delete_quiz'] >
		,
		ReturnType< $bog_blitz_admin_quiz['delete'] >
	>
	type $bog_blitz_admin_quiz__start_bog_blitz_admin_11 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin['start_quiz'] >
		,
		ReturnType< $bog_blitz_admin_quiz['start'] >
	>
	type $bog_blitz_admin_quiz__duplicate_bog_blitz_admin_12 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin['duplicate_quiz'] >
		,
		ReturnType< $bog_blitz_admin_quiz['duplicate'] >
	>
	type $bog_blitz_admin_quiz__share_bog_blitz_admin_13 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin['share_quiz'] >
		,
		ReturnType< $bog_blitz_admin_quiz['share'] >
	>
	type $mol_list__rows_bog_blitz_admin_14 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin['quiz_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_button_major__title_bog_blitz_admin_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_blitz_admin_16 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin['create_quiz'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_expander__title_bog_blitz_admin_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_blitz_admin_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_expander__title_bog_blitz_admin_19 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_blitz_admin_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_button_minor__sub_bog_blitz_admin_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_bog_blitz_admin_22 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin['back_to_list'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_status__sub_bog_blitz_admin_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_status['sub'] >
	>
	type $bog_blitz_admin_editor__quiz_land_bog_blitz_admin_24 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin['current_quiz_land'] >
		,
		ReturnType< $bog_blitz_admin_editor['quiz_land'] >
	>
	type $bog_blitz_admin_question__question_bog_blitz_admin_25 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin['question_obj'] >
		,
		ReturnType< $bog_blitz_admin_question['question'] >
	>
	type $bog_blitz_admin_question__number_bog_blitz_admin_26 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin['question_number'] >
		,
		ReturnType< $bog_blitz_admin_question['number'] >
	>
	type $bog_blitz_admin_question__question_text_bog_blitz_admin_27 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin['question_text'] >
		,
		ReturnType< $bog_blitz_admin_question['question_text'] >
	>
	type $bog_blitz_admin_question__question_type_bog_blitz_admin_28 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin['question_type'] >
		,
		ReturnType< $bog_blitz_admin_question['question_type'] >
	>
	type $bog_blitz_admin_question__delete_bog_blitz_admin_29 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin['delete_question'] >
		,
		ReturnType< $bog_blitz_admin_question['delete'] >
	>
	type $bog_blitz_admin_question__option_rows_bog_blitz_admin_30 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin['option_rows'] >
		,
		ReturnType< $bog_blitz_admin_question['option_rows'] >
	>
	type $bog_blitz_admin_question__add_option_bog_blitz_admin_31 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin['add_option'] >
		,
		ReturnType< $bog_blitz_admin_question['add_option'] >
	>
	export class $bog_blitz_admin extends $mol_page {
		admin_body( ): readonly(any)[]
		quiz_title( id: any, next?: string ): string
		quiz_is_shared( id: any): boolean
		edit_quiz( id: any, next?: any ): any
		delete_quiz( id: any, next?: any ): any
		start_quiz( id: any, next?: any ): any
		duplicate_quiz( id: any, next?: any ): any
		share_quiz( id: any, next?: any ): any
		quiz_rows( ): readonly(any)[]
		create_quiz( next?: any ): any
		import_bot_quiz( next?: any ): any
		Bot( ): $bog_blitz_admin_bot
		Import_hint( ): $mol_paragraph
		import_json_text( next?: string ): string
		Import_area( ): $mol_textarea
		import_json( next?: any ): any
		Import_button( ): $mol_button_major
		Back_icon( ): $mol_icon_arrow_left
		Back_label( ): string
		back_to_list( next?: any ): any
		Game_land_warning_text( ): $mol_paragraph
		current_quiz_land( ): any
		question_obj( id: any): any
		question_number( id: any): number
		question_text( id: any, next?: string ): string
		question_type( id: any, next?: string ): string
		delete_question( id: any, next?: any ): any
		option_rows( id: any): readonly(any)[]
		add_option( id: any, next?: any ): any
		Head( ): any
		body( ): ReturnType< $bog_blitz_admin['admin_body'] >
		Quiz_card( id: any): $bog_blitz_admin_quiz
		Quizzes_list( ): $mol_list
		Create_button( ): $mol_button_major
		Bot_expander( ): $mol_expander
		Import_expander( ): $mol_expander
		Back_button( ): $mol_button_minor
		Game_land_warning( ): $mol_status
		Editor( ): $bog_blitz_admin_editor
		Question( id: any): $bog_blitz_admin_question
	}
	
}

//# sourceMappingURL=admin.view.tree.d.ts.map